export default {
  HIDE: 'ws-dropdown:hide',
};
